import React from 'react';
import Heading from './components/Heading/Heading';
import DishControlPanel from './components/DishControlPanel/DishControlPanel';
import Dishes from './components/Dishes/Dishes';
import PaginationComponent from './components/PaginationComponent/PaginationComponent';
import style from './DishSection.module.scss';

const DishSection: React.FC = () => {
	return (
		<div className={style.container} data-test="DishSection">
			<div className={style.wrapper}>
				<div>
					<Heading />
					<DishControlPanel />
					<Dishes />
				</div>
				<PaginationComponent />
			</div>
		</div>
	);
};

export default DishSection;
